import { lazyRouteComponent } from "@tanstack/react-router";
import { LayoutList } from "lucide-react";

import type { PageDef } from "@/app/registry";

export const GROUP_KEYS = ["all", "broad", "sectoral", "thematic", "strategy", "bse"] as const;

export interface IndicesSearch {
  group: (typeof GROUP_KEYS)[number];
}

export const pages: PageDef[] = [
  {
    path: "/app/indices",
    title: "All indices",
    component: lazyRouteComponent(() => import("./IndicesPage"), "IndicesPage"),
    nav: { label: "All indices", icon: LayoutList, group: "Markets", order: 40 },
    validateSearch: (s): IndicesSearch => ({
      group: GROUP_KEYS.includes(s.group as IndicesSearch["group"]) ? (s.group as IndicesSearch["group"]) : "all",
    }),
  },
];
